import { useEffect, useState } from 'react'

import { ItemsApiProps } from 'services/account-info/types'
import { useAppInfo } from 'hooks/useAppInfo'

import IcCopy from '@interco/icons/core/action-navigation/ic_copy'
import { Flex, FlexColumn, FlexRow } from '@interco/inter-ui/components/Flex'
import { Divider, Text } from '@interco/inter-toranja'
import {
  TextSize,
  TextType,
  TextWeight,
} from '@interco/inter-toranja/dist/components/Atoms/Text/types'
import IcShare from '@interco/icons/core/action-navigation/ic_share'
import { interWbSession } from '@interco/inter-webview-bridge'
import { Spacing } from '@interco/inter-ui/components/Spacing'

interface CardProps {
  title?: string
  items?: ItemsApiProps[]
}

export const Card = ({ title, items }: CardProps) => {
  const [copied, setCopied] = useState<string>('')

  const { isDarkMode } = useAppInfo()
  const iconColor = isDarkMode ? '#FFFFFF' : '#1E1A19'

  useEffect(() => {
    setTimeout(() => {
      copied && setCopied('')
    }, 2000)
  }, [copied])

  const handleShareClick = () => {
    const message = items?.map(
      (item) => `${item.titulo}: ${item.dados[0] ?? ''} ${item.dados[1] ?? ''}\n`,
    )

    interWbSession.shareContent(`${title}:\n\n${message?.join('')}`)

    interWbSession.requestAnalytics('DADOS_BANCARIOS_GA_FLUXO', {
      ref_figma: '65',
      flow: 'dados-bancarios',
      screen: 'dados-bancarios',
      ref_type: 'button',
      content_action: 'touch',
      action_id: 'share',
      share: title ?? '',
    })
  }

  const handleCopyClick = (copyTitle: string, data: string) => {
    interWbSession.copyToClipboard(data, data)
    setCopied(copyTitle)

    interWbSession.requestAnalytics('DADOS_BANCARIOS_GA_FLUXO', {
      ref_figma: '66',
      flow: 'favoritos',
      screen: 'dados-bancarios',
      ref_type: 'input',
      content_action: 'touch',
      action_id: 'copy',
      copy: copyTitle,
    })
  }

  return (
    <Flex direction="column" gap="24px">
      <FlexRow alignItems="center" gap="0.5rem">
        <Text textSize={TextSize.Medium} textWeight={TextWeight.Bold} textType={TextType.Body}>
          {title}
        </Text>
        <IcShare width={24} height={24} color={iconColor} onClick={handleShareClick} />
      </FlexRow>

      <Flex direction="column" gap="24px">
        {items?.map((item) =>
          item.dados[1] ? (
            <FlexColumn key={item.titulo} gap="4px">
              <Divider variant="solid" />
              <Spacing my="xxxs" />

              <Text
                textSize={TextSize.Medium}
                textWeight={TextWeight.Bold}
                textType={TextType.Body}
              >
                {item.titulo}
              </Text>

              <Text
                textSize={TextSize.Medium}
                textWeight={TextWeight.Regular}
                textType={TextType.Body}
              >
                {item.dados[0]} <br />
                {item.dados[1]}
              </Text>
            </FlexColumn>
          ) : (
            <FlexColumn key={item.titulo} gap="4px">
              <FlexRow alignItems="center" justifyContent="space-between" gap="10px">
                <FlexColumn>
                  <Text
                    textSize={TextSize.Medium}
                    textWeight={TextWeight.Bold}
                    textType={TextType.Body}
                  >
                    {item.titulo}
                  </Text>

                  <Text
                    textSize={TextSize.Medium}
                    textWeight={TextWeight.Regular}
                    textType={TextType.Body}
                  >
                    {item.dados[0]}
                  </Text>
                </FlexColumn>

                {copied === item.titulo ? (
                  <IcCopy width={24} height={24} color="var(--gray400)" />
                ) : (
                  <IcCopy
                    width={24}
                    height={24}
                    color={iconColor}
                    onClick={() => handleCopyClick(item.titulo, item.dados[0])}
                  />
                )}
              </FlexRow>
            </FlexColumn>
          ),
        )}
      </Flex>
    </Flex>
  )
}
